var GoingValidationClass = (function () {
    function GoingValidationClass() {
    }
    return GoingValidationClass;
})();
GoingValidationClass.prototype = {
    /**
     * 校验值是不是null
     * @param funcStr
     */
    isNotNull: function (funcStr) {
        if (funcStr != null && typeof funcStr != undefined) {
            return true;
        }
        else {
            return false;
        }
    },
    //校验是否为空
    isEmpty: function (a) {
        return a == "";
    },
    //校验是否不为空
    isNotEmpty: function (a) {
        return a instanceof Array ? a.length > 0 : a !== "";
    },
    //校验是否为boolean
    isValidBoolean: function (a) {
        return !!a.toString().match(/^(0|1|true|false)$/);
    },
    //校验是否为邮件
    isValidEmail: function (a) {
        return !!a
            .toString()
            .match(/(^[a-z0-9]([0-9a-z\-_.]*)@([0-9a-z_\-.]*)([.][a-z]{3})$)|(^[a-z]([0-9a-z_.-]*)@([0-9a-z_\-.]*)(\.[a-z]{2,5})$)/i);
    },
    //校验是否为整形
    isValidInteger: function (a) {
        return !!a.toString().match(/(^-?\d+$)/);
    },
    //校验是否为数字
    isValidNumeric: function (a) {
        return !!a
            .toString()
            .match(/(^-?\d\d*[.|,]\d*$)|(^-?\d\d*$)|(^-?[.|,]\d\d*$)/);
    },
    //校验是否为alb数字
    isValidAplhaNumeric: function (a) {
        return !!a.toString().match(/^[_\-a-z0-9]+$/gi);
    },
    //校验是否为日期带时间
    isValidDatetime: function (c) {
        var a = c
            .toString()
            .match(/^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/);
        return ((a &&
            !!(a[1] <= 9999 &&
                a[2] <= 12 &&
                a[3] <= 31 &&
                a[4] <= 59 &&
                a[5] <= 59 &&
                a[6] <= 59)) ||
            false);
    },
    //校验是否为日期
    isValidDate: function (a) {
        var c = a.toString().match(/^(\d{4})-(\d{2})-(\d{2})$/);
        return (c && !!(c[1] <= 9999 && c[2] <= 12 && c[3] <= 31)) || false;
    },
    //校验是否为时间
    isValidTime: function (c) {
        var a = c.toString().match(/^(\d{1,2}):(\d{1,2}):(\d{1,2})$/);
        return (a && !!(a[1] <= 24 && a[2] <= 59 && a[3] <= 59)) || false;
    },
    //校验是否为ip4
    isValidIPv4: function (a) {
        var c = a.toString().match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
        return ((c && !!(c[1] <= 255 && c[2] <= 255 && c[3] <= 255 && c[4] <= 255)) ||
            false);
    },
    isValidCurrency: function (a) {
        return ((a.toString().match(/^\$?\s?\d+?([.,]?\d+)?\s?\$?$/) && true) || false);
    },
    isValidSSN: function (a) {
        return (a.toString().match(/^\d{3}-?\d{2}-?\d{4}$/) && true) || false;
    },
    isValidSIN: function (a) {
        return (a.toString().match(/^\d{9}$/) && true) || false;
    }
};
var goingValidation = new GoingValidationClass();

export default goingValidation;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/goingValidationClass.js